import { render } from "./ActionIcon.vue?vue&type=template&id=37d572ed"
import script from "./ActionIcon.vue?vue&type=script&lang=js"
export * from "./ActionIcon.vue?vue&type=script&lang=js"
script.render = render

export default script